import React, { Fragment, useRef } from 'react';
import { translate } from '../Services/translation';

const NavigationItem = ({ links = [], contentLink = null, depth }) => {
    const menuRef = useRef(null);
    const toggleMenu = (e) => {
        setTimeout(
            () => menuRef.current.scrollIntoView({ behavior: 'smooth' }),
            250
        );
        e.preventDefault();
        menuRef.current.classList.toggle('navbar__menu--show');
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    const ConditionalWrapper = ({ condition, wrapper, children }) =>
        condition ? wrapper(children) : children;

    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMenu}
                    rel="nofollow"
                    href="#"
                    title={translate('general.menu') || 'menu'}
                ></a>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${
                            hasChildrenClass || ''
                        } ${additionClass || ''}`}
                        href={contentLink.url || '#'}
                        dangerouslySetInnerHTML={{ __html: contentLink.name }}
                    ></a>
                    {links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        ></i>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <ul className="navbar__menu" ref={menuRef}>
                    <ConditionalWrapper
                        condition={depth === 1}
                        wrapper={(children) => (
                            <>
                                <div className="navbar__top-border-blocker"></div>
                                <div className="navbar__megamenu-wrapper">
                                    {children}
                                </div>
                            </>
                        )}
                    >
                        <div className="navbar__menu-header">
                            {!contentLink ? (
                                <span
                                    className="navbar__icon navbar__icon--close"
                                    onClick={toggleMenu}
                                ></span>
                            ) : (
                                <Fragment>
                                    <i
                                        className="navbar__icon--caret-left navbar__icon"
                                        onClick={toggleMenu}
                                    ></i>
                                    <span
                                        className="navbar__title"
                                        onClick={toggleMenu}
                                        dangerouslySetInnerHTML={{
                                            __html: contentLink.name,
                                        }}
                                    ></span>
                                </Fragment>
                            )}
                        </div>
                        {links.length > 0 &&
                            links.map(
                                (link, i) =>
                                    hasNameOrChildren(link) && (
                                        <li
                                            className="navbar__item"
                                            key={link.url ? link.url : i}
                                        >
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                                depth={depth + 1}
                                            />
                                        </li>
                                    )
                            )}
                    </ConditionalWrapper>
                </ul>
            )}
        </Fragment>
    );
};

export default NavigationItem;
